var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import { convertToCSSValue, getGeometryStyle } from '../../helpers/styles';
import { isTrue } from '../../helpers/utils';
import ChildItemWidget from '../ChildItemWidget';
var StyledListWidget = styled.div.attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  box-sizing: ", ";\n  ", "\n  border: ", ";\n  border-left-color: ", ";\n  border-top-color: ", ";\n  border-right-color: ", ";\n  border-bottom-color: ", ";\n  background-color: ", ";\n  ", "\n"], ["\n  box-sizing: ", ";\n  ", "\n  border: ", ";\n  border-left-color: ",
    ";\n  border-top-color: ",
    ";\n  border-right-color: ",
    ";\n  border-bottom-color: ",
    ";\n  background-color: ",
    ";\n  ",
    "\n"])), function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.listWidget.boxSizing;
}, function (_a) {
    var geometry = _a.attributes.geometry;
    return getGeometryStyle(geometry);
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.listWidget.border;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.listWidget.borderColor.left;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.listWidget.borderColor.top;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.listWidget.borderColor.right;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.listWidget.borderColor.bottom;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.listWidget.backgroundColor;
}, function (_a) {
    var attributes = _a.attributes;
    var wordWrap = attributes.wordWrap, horizontalScrollBarPolicy = attributes.horizontalScrollBarPolicy, verticalScrollBarPolicy = attributes.verticalScrollBarPolicy, maximumSize = attributes.maximumSize, minimumSize = attributes.minimumSize;
    return "\n            overflow-x: " + (horizontalScrollBarPolicy === 'ScrollBarAlwaysOn'
        ? 'scroll'
        : 'hidden') + ";\n            overflow-y: " + (verticalScrollBarPolicy === 'ScrollBarAlwaysOn'
        ? 'scroll'
        : 'hidden') + ";\n            max-height: " + (maximumSize ? convertToCSSValue(maximumSize.height) : '') + ";\n            max-width: " + (maximumSize ? convertToCSSValue(maximumSize.width) : '') + ";\n            min-height: " + (minimumSize ? convertToCSSValue(minimumSize.height) : '') + ";\n            min-width: " + (minimumSize ? convertToCSSValue(minimumSize.width) : '') + ";\n\n            div {\n                white-space: " + (isTrue(wordWrap) ? 'normal' : 'nowrap') + ";\n            }\n        ";
});
var ListWidget = function (props) {
    return (React.createElement(StyledListWidget, __assign({}, props),
        React.createElement(ChildItemWidget, __assign({}, props))));
};
export default ListWidget;
var templateObject_1;
//# sourceMappingURL=index.js.map